export const Description = () => {
    return (
        <div className="description">
            <div className="description__title">
                Milieuzone ontheffing checker
            </div>
            <div className="description__content">
                Checkt of voor uw voertuig een ontheffing nodig is
            </div>
        </div>
    );
}
